import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { usePostHog } from 'posthog-js/react'

export const PostHogPageView = () => {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    if (posthog.capture && import.meta.env.VITE_POSTHOG_ENABLED === `true`) {
      posthog.capture(`$pageview`, {
        $current_url: window.location.href
      })
    }
  }, [posthog, location])

  return null
}
